import { Table, Typography } from 'antd';
import styled from 'styled-components';
import PropTypes from 'prop-types';
const { Text } = Typography;

const GoodsTable = styled(Table)`
	table {
		text-align: center;
		tbody {
			tr {
				td.ant-table-cell {
					box-sizing: border-box;
					font-size: 12px;
					padding: 0px !important;
				}
			}
}`;
const columns = [
	{
		title: 'Description',
		key: 'index',
		dataIndex: 'goods_description',
		render: (value) => <p>{value}</p>,
	},
	{
		title: 'Quantity',
		key: 'index',
		dataIndex: 'goods_quantity',
		render: (value) => <p>{value}</p>,
	},
	{
		title: 'Unit',
		key: 'index',
		dataIndex: 'goods_uom',
		render: (value) => <p>{value.toUpperCase()}</p>,
	},
	{
		title: 'Length (in)',
		key: 'index',
		dataIndex: 'goods_length',
		render: (value) => <p>{value}</p>,
	},
	{
		title: 'Width (in)',
		key: 'index',
		dataIndex: 'goods_width',
		render: (value) => <p>{value}</p>,
	},
	{
		title: 'Height (in)',
		key: 'index',
		dataIndex: 'goods_height',
		render: (value) => <p>{value}</p>,
	},
	{
		title: 'Weight (kg)',
		key: 'index',
		dataIndex: 'goods_weight',
		render: (value) => <p>{value}</p>,
	},
];

export function LRViewGoodsDetails({ Items }) {
	const ItemsWithKeys = (Items || []).map((item, index) => ({ ...item, key: index + 1 }));
	return (
		<>
			<Text>Goods Details:</Text>
			<GoodsTable
				rowClassName="LRTableDetailsRows"
				bordered
				columns={columns}
				dataSource={ItemsWithKeys}
				pagination={false}
				size="small"
				rowKey="key"
			/>
		</>
	);
}

LRViewGoodsDetails.propTypes = {
	Items: PropTypes.array,
};
